export default __webpack_public_path__ + "static/media/lion_ANGRY.663cda84.png";